import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';
import { FcmService } from '../../service/fcm.service';

@Component({
  selector: 'app-add-offer',
  templateUrl: './add-offer.component.html',
  styleUrls: ['./add-offer.component.css']
})
export class AddOfferComponent implements OnInit {
  OfferForm: FormGroup;
  cover_image: File;
  cover_image_url: any;
  loading: boolean = false;
  load: boolean = false;
  coverimageerror: any = false;
  id: string="";
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef,private fcmSr:FcmService) {
    this.toastr.setRootViewContainerRef(vcr);
    }

  ngOnInit() {
    this.initForm();
        // getting the available eseries from the database
        this.route.paramMap.subscribe(params => {
          this.id =params.get('id');
          if (this.id) {
            this.comicService.getsinglecomic(this.id, 'Offers').then(data => {
              // const admindata = data.valueChanges();
              data.subscribe(SingleData => {
                const data = SingleData;
                console.log(data)
                this.OfferForm.get('offer_name').setValue(data['offer_name']);
                this.OfferForm.get('offer_description').setValue(data['offer_description']);
                this.OfferForm.get('website_link').setValue(data['website_link']);
                const date = new Date(data['expiry_date'].seconds*1000);
                this.OfferForm.get('expiry_date').setValue(date);
                this.OfferForm.get('cover_image').setValue(data['cover_image']);
                this.cover_image_url = data['cover_image'];
        
              });
            });
          }
        });
  }
  initForm(){
    this.OfferForm = this.form.group({
      offer_name: ['', [Validators.required]],
      offer_description: ['', [Validators.required]],
      website_link:['',[Validators.required]],
      expiry_date: ['', [Validators.required]],
      cover_image: ['', []],
    });
  }
  changeListner2(event) {
    this.coverimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
    
  }
  async addchapter(value, valid) {
        if (valid) {
          this.loading = true;
          if (this.id) {
            let coverimage;
            // Checking if the cover image is changed if changed the update the image in sapces and also db.
            if (this.cover_image) {
              coverimage = await this.auth.uploadimage('offer/cover/', this.cover_image, false);
              this.OfferForm.get('cover_image').setValue(coverimage['Location']);
            }
            let data = this.OfferForm.value;
            data.expiry_date = new Date(this.OfferForm.value.expiry_date);
            data.expiry  = new Date(this.OfferForm.value.expiry_date).toString();
            const document = await this.afs.doc(`/Offers/${this.id}`);
            const update = await document.update(data);
            await this.toastr.success('Offer updated successfully!', 'Success!');
            setTimeout(() => {
              this.router.navigate(['/offers']);
            }, 2000);
            this.loading = false;
            return;
          }
          if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
          const coverimage = await this.auth.uploadimage('offer/cover/', this.cover_image, false);
          var CoverImg  = coverimage['Location'];
          this.OfferForm.get('cover_image').setValue(CoverImg);
          let data = this.OfferForm.value;
          data.expiry_date = new Date(this.OfferForm.value.expiry_date);
          data.expiry  = new Date(this.OfferForm.value.expiry_date).toString();
          data.createdAt = new Date(),
          data.date = new Date().toString(),
          console.log(data);
          const offerAdd = await this.afs.collection('Offers').add(data);
          const offerId = offerAdd.id;
          const id = await this.afs.doc(`/Offers/${offerId}`).update({ id: offerId });
          this.toastr.success('Offer Added successfully!', 'Success!');
          let FCMdata = {
            "to":`/topics/all`,
            "notification": {
                "title": `Webnnel Added a New Offer`,
                "body": data.offer_description,
                "sound": "default",
            },
             data: {
              "title": `Webnnel Added a New Offer`,
                "body": data.offer_description,
                "sound": "default",
                "appUrl":"/tabs/offers",
                "type":"Offers",
            },
            android: {
              notification: {
                imageUrl: CoverImg
              }
            },
            apns: {
              payload: {
                aps: {
                  'mutable-content': 1
                }
              },
              fcm_options: {
                image: CoverImg
              }
            },
            webpush: {
              headers: {
                image: CoverImg
              }
            },
        };
        this.fcmSr.postDataWithToken(FCMdata).subscribe((response)=>{
          setTimeout(() => {
            this.router.navigate(["/offers"]);
          }, 2000);
        },error=>{
          setTimeout(() => {
            this.router.navigate(["/offers"]);
          }, 2000);
        })
        this.loading = false;
        }
      }

}



// WEBPACK FOOTER //
// ./src/app/offers/add-offer/add-offer.component.ts